// Generic imports
import React from "react"

// Other components imports
import Button from "components/Button"
import Image from "components/image"
import { Styles } from "components/Reusable/Modal/style"

// Redux imports

// Static imports

// Utils imports

const Modal = ({ title, body, visible, btnText, btnClicked }) => {
  if (!visible) return <></>
  return (
    <Styles>
      <div className="success-modal">
        <div className="success-modal-img">
          <Image imgName="modal-success.png" alt="Success" />
        </div>
        <h5>{title}</h5>
        <div>{body}</div>
        <Button onClick={btnClicked}>{btnText}</Button>
      </div>
    </Styles>
  )
}

export default Modal
